import React from 'react';
import { ArrowRightIcon } from '@/features/Icons/ArrowRightIcon';
import './styles/draggableContainer.scss';

interface DraggableContainerProps {
  children: React.ReactNode;
  containerClassName: string;
  showLeftButton: boolean;
  showRightButton: boolean;
  onScrollLeft: () => void;
  onScrollRight: () => void;
  onScroll: () => void;
  scrollRef: React.RefObject<HTMLDivElement | null>;
  contentRef: React.RefObject<HTMLDivElement | null>;
}

export const DraggableContainer: React.FC<DraggableContainerProps> = ({
  children,
  containerClassName,
  showLeftButton,
  showRightButton,
  onScrollLeft,
  onScrollRight,
  onScroll,
  scrollRef,
  contentRef,
}) => {
  return (
    <div className={containerClassName} data-testid="draggable-container">
      {showLeftButton && (
        <button
          className="draggable-container__button draggable-container__button--left"
          onClick={onScrollLeft}
          aria-label="Scroll left"
          type="button"
        >
          <ArrowRightIcon />
        </button>
      )}
      {showRightButton && (
        <button
          className="draggable-container__button draggable-container__button--right"
          onClick={onScrollRight}
          aria-label="Scroll right"
          type="button"
        >
          <ArrowRightIcon />
        </button>
      )}
      <div
        className="draggable-container__scroll"
        ref={scrollRef}
        onScroll={onScroll}
        data-testid="draggable-container-scroll"
      >
        <div className="draggable-container__content" ref={contentRef}>
          {children}
        </div>
      </div>
    </div>
  );
};
